import React from "react";

import { Box, Text, VStack } from "../../primitive";
import { PanelHeaderChildWrapper } from "./components/PanelHeaderChildWrapper";

export type PanelHeaderProps = {
  header: string;
  subHeader?: string;
  outerLeftComponent?: React.ReactNode;
  innerLeftComponent?: React.ReactNode;
  outerRightComponent?: React.ReactNode;
  innerRightComponent?: React.ReactNode;
  paddingVariant?: "small" | "medium";
  hideBottomBorder?: boolean;
};

export const PanelHeader = ({
  header,
  subHeader,
  outerLeftComponent,
  innerLeftComponent,
  innerRightComponent,
  outerRightComponent,
  paddingVariant = "small",
  hideBottomBorder = false,
}: PanelHeaderProps) => {
  const isSmall = paddingVariant === "small";
  return (
    <Box
      borderBottomWidth={hideBottomBorder ? 0 : 1}
      backgroundColor="surface-primary"
      borderColor="outline-default"
      p={paddingVariant === "small" ? 2 : 5}
      justifyContent="center"
      alignItems="center"
      height={isSmall ? 64 : 84}
    >
      {outerLeftComponent ? (
        <PanelHeaderChildWrapper left={isSmall ? 8 : 20}>
          {outerLeftComponent}
        </PanelHeaderChildWrapper>
      ) : null}
      {innerLeftComponent ? (
        <PanelHeaderChildWrapper left={56}>
          {innerLeftComponent}
        </PanelHeaderChildWrapper>
      ) : null}
      <VStack justifyContent="center" alignItems="center" width="100%">
        <Text>{header}</Text>
        {subHeader ? (
          <Text variant="mainTiny" color="text-secondary">
            {subHeader}
          </Text>
        ) : null}
      </VStack>
      {innerRightComponent ? (
        <PanelHeaderChildWrapper right={56}>
          {innerRightComponent}
        </PanelHeaderChildWrapper>
      ) : null}
      {outerRightComponent ? (
        <PanelHeaderChildWrapper right={isSmall ? 8 : 20}>
          {outerRightComponent}
        </PanelHeaderChildWrapper>
      ) : null}
    </Box>
  );
};
